import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import { hasAuthorization } from '../utils/helpers'
import LoadingIndicator from '../components/loadingIndicator'
import { logout } from '../modules/authProfile'
import MainLayout from './mainLayout'
import Messages from '../constants/messages'
import Unauthorized from '../pages/unauthorized'
import { withRouter } from 'react-router-dom'
import withStyles from 'material-ui/styles/withStyles'

const PROP_TYPES = {
  classes: PropTypes.object.isRequired,
  component: PropTypes.func.isRequired,
  allowedMemberships: PropTypes.array.isRequired,
  allowedRoles: PropTypes.array
}

const styles = theme => ({

})

export class AuthWrapper extends Component {

  render() {
    const { allowedRoles, allowedMemberships, authProfile, isDoneAuthorizing, logout } = this.props
    const Component = this.props.component
    const { userMemberships, userRoles } = authProfile
    let markup = null
    if (!isDoneAuthorizing) {
      markup =  <LoadingIndicator infoText={Messages['uiComponents']['AUTHORIZING_MSG']} />
    } else if (isDoneAuthorizing && !hasAuthorization(userMemberships, userRoles, allowedMemberships, allowedRoles)) {
      markup = <Unauthorized authProfile={authProfile} logout={logout}/>
    } else {
      markup = <MainLayout component={Component} />
    }
    return markup
  }
}

AuthWrapper.propTypes = PROP_TYPES

const mapStateToProps = state => ({
  authProfile: state.authProfile,
  isDoneAuthorizing: state.authProfile.isDoneAuthorizing
})

const mapDispatchToProps = dispatch => bindActionCreators({
  logout: logout
}, dispatch)

export default withRouter(
    compose(
      withStyles(styles),
      connect(
        mapStateToProps,
        mapDispatchToProps
      )
)(AuthWrapper))
